<template>
    <div class="m-promoPreviewSmallDetails">
        <div class="d-flex justify-content-between align-items-start">
            <p class="typo typo--name mb-2 mb-md-0" v-text="promotionName" />

            <div
                class="d-flex gap-0-5 justify-content-between o-promoPreview__heartWrapper"
            >
                <button
                    v-if="showAttachmentsBtn"
                    v-tooltip="'Pobierz materiały promocyjne'"
                    class="btn btn-icon text-primary p-0"
                    style="height: 24px"
                    @click.prevent.stop="
                        () =>
                            onAttachmentsDownload(promotion.id, promotion.name)
                    "
                >
                    <a-icon
                        v-if="
                            !(
                                promoAttachmentsStatus.promoId ===
                                promotion.id &&
                                promoAttachmentsStatus.status === 'loading'
                            )
                        "
                        icon="Download"
                    />
                    <button-spinner
                        class="ml-3"
                        :status="
                            promoAttachmentsStatus.promoId === promotion.id
                                ? promoAttachmentsStatus.status
                                : 'idle'
                        "
                    />
                </button>

                <!-- Icons -->
                <a-icon
                    v-if="promotion.smokingSegment"
                    v-tooltip="'Strefa palacza'"
                    class="text-primary"
                    width="20px"
                    icon="SmokingSegment"
                />
                <a-icon
                    v-if="$store.getters.isWeight(promotion.type)"
                    v-tooltip="'Promocja wagowa'"
                    class="text-primary"
                    width="20px"
                    icon="Scale"
                />
                <a-icon
                    v-else-if="!promotion.all_eans_present"
                    v-tooltip="'Promocja z możliwością uzupełnienia kodów lokalnych'"
                    icon="Barcode"
                    class="text-primary"
                    width="24px"
                />
                <promotion-preview-heart
                    v-if="
                        previewType === 'promo-list' ||
                            previewType === 'promo-later'
                    "
                    :id="promotion.id"
                    @click="favorite => toggleFavorites(promotion.id, favorite)"
                />
                <!-- /Icons -->
            </div>
        </div>

        <p class="typo typo--secondary mb-2 mb-md-0" v-text="promoType" />

        <div class="d-flex flex-wrap" style="gap: 0.25rem 0.5rem">
            <span class="typo typo--secondary">
                Od
                <time datetime>
                    <strong>
                        {{
                            $moment(promotion.start_at).format('DD-MM-YYYY')
                        }}&nbsp;
                    </strong>
                    {{ $moment(promotion.start_at).format('HH:mm') }}
                </time>
                do
                <time datetime>
                    <strong>
                        {{
                            $moment(promotion.end_at).format('DD-MM-YYYY')
                        }}&nbsp;
                    </strong>
                    {{ $moment(promotion.end_at).format('HH:mm') }}
                </time>
            </span>

            <span
                v-if="
                    lockedAtText &&
                        ($route.name === 'promo-list' ||
                            $route.name === 'promo-later' ||
                            previewType === 'group-accept')
                "
                class="typo typo--secondary text-orange"
            >
                {{ lockedAtText }}
                <a-icon
                    v-tooltip="
                        `Po wskazanej dacie aktywacja nie będzie możliwa, a promocja
                        zostanie przeniesiona do zakładki
                        <strong><i>Archiwalne</i></strong>.`
                    "
                    style="width: 12px; height: 12px; transform: translate(2px, 2px);"
                    icon="Warning"
                />
            </span>
        </div>

        <div
            v-if="isPromoLabels || company"
            class="
                m-promoPreviewSmallDetails__producerStatsWrapper
                d-flex justify-content-between align-items-start mt-2
            "
            :class="{ 'pr-md-4': previewType === 'promo-yours' }"
        >
            <div
                v-if="company"
                class="tr-brand mt-0"
                :class="{
                    'is-large': company.type === 'Retailer::Company'
                }"
                :style="
                    `background-image: url(${
                        company.type === 'Retailer::Company'
                            ? '/img/icons/ep/own_promo.png'
                            : company && company.logo && company.logo.urls.small
                    })`
                "
            ></div>
            <div class="m-promoPreviewSmallDetails__badges d-flex">
                <div
                    v-if="promotion.subscriptions_auto_acceptance"
                    v-tooltip="'Promocja aktywowana przez centralę'"
                    class="a-badge a-badge--warning"
                >
                    Centrala
                    <a-icon icon="Info" />
                </div>

                <div
                    v-if="promotion.featured"
                    v-text="promotion.featured_text || 'Wyróżniona'"
                    class="a-badge text-nowrap"
                />

                <div
                    v-if="promotion.loyalty"
                    v-text="'Tylko z aplikacją'"
                    class="a-badge a-badge--success text-nowrap"
                />
                <div
                    v-if="promotion.usage_limit_per_loyalty_card"
                    v-tooltip="
                        `Promocja ma limit użyć na kartę klienta: ${Number(
                            promotion.usage_limit_per_loyalty_card
                        )}`
                    "
                    class="a-badge a-badge--success text-nowrap"
                >
                    Limit na kartę
                    <a-icon icon="Info" />
                </div>
            </div>
        </div>

        <div class="m-promoPreviewSmallDetails__bottomBelt mt-1">
            <div
                class="m-promoPreviewSmallDetails__producerStatsWrapper flex-wrap pr-md-4"
            >
                <div>
                    <div
                        v-if="showShopsCounter"
                        class="m-promoPreviewSmallDetails__shopsAvailability"
                    >
                        {{ shopsCounterTitle }} w
                        <strong class="text-primary px-1">
                            {{
                                subscriptions.filter(
                                    el => el.state === shopsCounterKeyword
                                ).length
                            }}
                        </strong>
                        z
                        <span
                            class="m-promoPreviewSmallDetails__shopsAvailabilityCounter pl-1"
                            v-html="
                                $options.filters.plurals(
                                    subscriptions.length,
                                    'sklepu',
                                    'sklepów',
                                    undefined,
                                    true
                                )
                            "
                        ></span>
                    </div>
                </div>
                <div class="m-promoPreviewSmallDetails__stats gap-0-5">
                    <div
                        v-if="showState"
                        class="m-promoPreviewSmallDetails__state"
                    >
                        <span
                            v-if="promotion.state === 'cancelled'"
                            class="status is-canceled"
                        >
                            <span>Anulowana</span>
                        </span>
                        <span
                            v-else-if="promotion.state === 'finished'"
                            class="status is-finished"
                        >
                            <span>Zakończona</span>
                        </span>
                        <span v-else-if="isSuspended" class="status is-warning">
                            <span>Zawieszona</span>
                        </span>
                        <span
                            v-else-if="isLocked"
                            class="status is-warning"
                            v-tooltip="
                                `Czas na aktywację promocji minął: ${$moment(
                                    promotion.locked_at
                                ).format('DD-MM-YYYY, HH:mm')}`
                            "
                        >
                            <span>Zablokowana</span>
                            <a-icon icon="Info" />
                        </span>
                    </div>
                    <div
                        v-if="showProgress"
                        class="text-primary font-weight-bold m-promoPreviewSmallDetails__progress"
                    >
                        <span class="mb-1">
                            <strong>{{ daysLeft.countText }}</strong> pozostało
                            <span class="nowrap">
                                <span
                                    class="text-dark"
                                    v-html="daysLeft.diff"
                                ></span>
                                <template v-if="!daysLeft.promotionIncoming">
                                    <strong>&nbsp;z&nbsp;
                                        <span class="text-dark">
                                            {{ durationDays }}
                                        </span>
                                    </strong>
                                </template>
                            </span>
                        </span>
                        <div
                            class="progress"
                            :class="{
                                'progress--incoming': daysLeft.promotionIncoming
                            }"
                        >
                            <div
                                role="progressbar"
                                class="progress-bar"
                                :style="`width: ${progressWidth}%`"
                            ></div>
                        </div>
                    </div>
                    <div
                        v-if="showNetReturn"
                        class="m-promoPreviewSmallDetails__netRefund font-weight-bold"
                    >
                        <span
                            class="
                                m-promoPreviewSmallDetails__netRefundTitle
                                text-primary d-inline-block
                            "
                        >
                            {{
                                promotion.type === PROMO_TYPES.SALES_TARGET
                                    ? 'Nagroda netto' : 'Zwrot netto'
                            }}
                        </span>
                        <span class="text-dark ml-1 m-promoPreviewSmallDetails__netRefundAmount">
                            {{ totalRefund }}
                        </span>
                    </div>
                    <div
                        v-if="showProductsCounter"
                        class="m-promoPreviewSmallDetails__productsCounter"
                    >
                        Liczba produktów
                        <span
                            v-if="totalProductsRecords"
                            class="font-weight-bold text-primary px-3"
                        >{{ totalProductsRecords }}</span>
                        <span v-else class="tr-data__dd">
                            <page-preloader small min-height="20px" />
                        </span>
                    </div>
                </div>
            </div>
            <the-btn
                v-if="!promoGroupAcceptView"
                @click.native="$emit('showMore')"
                class="mt-3 btn-custom-gray d-md-none mb-3"
            >
                {{ showMore ? 'Pokaż mniej' : 'Pokaż więcej' }}
                <a-icon
                    icon="Dropdown"
                    :style="showMore ? 'transform: rotate(180deg)' : ''"
                />
            </the-btn>

            <div
                v-if="promoGroupAcceptView"
                class="m-promoPreviewSmallDetails__options mt-2 flex-wrap flex-sm-nowrap"
            >
                <the-btn
                    class="
                        m-promoPreviewSmallDetails__showPromoDetailsBtn
                        btn-custom-gray btn-block
                    "
                    @click.native.stop.prevent="onChangeShowMore"
                >
                    <a-icon
                        :icon="showMore ? 'ArrowUp' : 'ArrowDown'"
                        class="mr-1 mr-sm-2"
                        width="16px"
                    />
                    {{
                        this.previewType === 'labels'
                            ? 'Dostosuj ceny poza promocją'
                            : 'Szczegóły promocji'
                    }}
                    <button-spinner
                        class="ml-3"
                        v-if="
                            this.previewType === 'labels' &&
                                !showMore &&
                                !changedShowMore &&
                                emptyMandatoryPrice &&
                                $store.getters.isServiceActive('shop_tag')
                        "
                        status="loading"
                    />
                    <a-icon
                        v-else-if="
                            this.previewType === 'labels' && emptyMandatoryPrice
                        "
                        class="text-danger"
                        icon="InvalidMark"
                    />
                </the-btn>
                <the-btn
                    class="btn btn-custom-gray w-100 d-flex d-sm-none"
                    icon="Bin"
                    @click.native.stop.prevent="onPromotionDelete"
                >
                </the-btn>
                <the-btn
                    class="btn btn-custom-gray d-none d-sm-flex"
                    icon="Bin"
                    @click.native.stop.prevent="onPromotionDelete"
                >
                </the-btn>
            </div>

            <div v-if="showButtons" class="align-self-md-end align-self-auto">
                <div @click.stop.prevent v-if="!selectionConflict">
                    <the-btn
                        v-if="showAcceptButton"
                        :disabled="
                            lockedTimesUp ||
                                promoCheckboxDisabled ||
                                group.loadingSelectedPromoIds
                        "
                        @click.native.stop.prevent="
                            () =>
                                !promoCheckboxDisabled &&
                                !group.loadingSelectedPromoIds &&
                                onPromotionSelect()
                        "
                        btn-class=""
                        :text="
                            selected
                                ? 'Dodano do aktywacji'
                                : 'Dodaj do aktywacji'
                        "
                        :class="
                            `btn-custom-gray m-promoPreviewSmallDetails__action ${
                                selected ? 'active' : ''
                            }`
                        "
                        :id="
                            `${
                                this.acceptance === 'all'
                                    ? ''
                                    : selected
                                        ? 'remove-from'
                                        : 'add-to' + '-card-promo'
                            }`
                        "
                        v-tooltip="{
                            content: tooltipContent
                        }"
                    >
                        <a-icon
                            class="ml-2"
                            :icon="selected ? 'Approval' : 'Plus'"
                            height="18px"
                            width="18px"
                        />
                    </the-btn>
                    <the-btn
                        v-if="previewType === 'promo-labels'"
                        :disabled="
                            loaderSelectLabel === 'loading' ||
                                !totalProductsRecords ||
                                promotion.productsStatus === 'loading'
                        "
                        @click.native.stop.prevent="onPromoLabelSelect"
                        btn-class=""
                        :text="
                            selectLabel
                                ? 'Dodano do generowania'
                                : 'Dodaj do generowania'
                        "
                        class="
                            m-promoPreviewSmallDetails__action
                            m-promoPreviewSmallDetails__actionPromoLabels btn-custom-gray
                        "
                        :class="{ active : selectLabel }"
                        :id="
                            `${
                                selectLabel
                                    ? 'remove-from'
                                    : 'add-to' + '-card-promo'
                            }`
                        "
                    >
                        <button-spinner
                            v-if="loaderSelectLabel === 'loading'"
                            class="ml-2"
                            :status="loaderSelectLabel"
                        />
                        <a-icon
                            v-else
                            class="ml-2"
                            :icon="selectLabel ? 'Approval' : 'Plus'"
                            height="18px"
                            width="18px"
                        />
                    </the-btn>
                </div>
                <div
                    v-else
                    v-tooltip="{
                        content: tooltipContent
                    }"
                    @click.stop.prevent="onPromotionSelect"
                    class="m-promoPreviewSmallDetails__action --error"
                >
                    {{ selectionConflict }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import PromotionPreviewHeart from '@/components/promotions/promotionsPreview/PromotionPreviewHeart'
import { PROMO_TYPES } from '@/utils/constants/promo-types'

export default {
    name: 'PromotionPreviewSmallDetails',
    components: {
        PromotionPreviewHeart
    },
    data() {
        return {
            loaderSelectLabel: 'idle',
            lockedAtText: '',
            lockedAtInterval: null,
            lockedTimesUp: false,
            changedShowMore: false
        }
    },
    props: {
        previewType: {
            type: String,
            default: ''
        },
        showMore: {
            type: Boolean,
            default: false
        },
        groupId: { type: Number, required: false, default: null },
        acceptance: { type: String, default: '' },
        isActivePromosTab: { type: Boolean, default: false },
        usageLimitPerLoyaltyCard: { type: String, default: '' },
        promotion: { type: Object, required: true }
    },
    created() {
        this.PROMO_TYPES = PROMO_TYPES
    },
    computed: {
        subscriptions() {
            return this.promotion.subscriptions || []
        },
        promoGroupAcceptView() {
            return (
                this.previewType === 'group-accept' ||
                this.previewType === 'labels'
            )
        },
        showAcceptButton() {
            return (
                this.isPromoEditPermission &&
                (this.$route.name === 'promo-list' ||
                    this.$route.name === 'promo-later')
            )
        },
        countRejectedSubscriptionsToday() {
            const today = this.$moment().format('YYYY-MM-DD')

            return this.subscriptions.filter(subscription => {
                return (
                    subscription.state === 'interrupted' &&
                    subscription.updated_at?.slice(0, 10) === today
                )
            }).length
        },

        tooltipContent() {
            if (this.subscriptions.find(el => el.state === 'incompatible')) {
                // If there is at least one incompatible subscription
                return 'Stanowiska kasowe w sklepie nie obsługują tego typu promocji. Aby aktywować promocję, zaktualizuj kasę lub system sprzedażowy do najnowszej wersji oprogramowania. Zadzwoń, jeśli potrzebujesz wsparcia 22&nbsp;123&nbsp;84&nbsp;00.'
            } else if (this.countRejectedSubscriptionsToday === this.subscriptions.length) {
                // All subscriptions rejected today
                return 'Promocja została przerwana. Ponowna aktywacja będzie możliwa jutro'
            } else if (this.countRejectedSubscriptionsToday > 0) {
                // Some subscriptions rejected today
                return 'Promocja została przerwana w wybranych sklepach. Ponowna aktywacja promocji w tych sklepach będzie możliwa jutro.'
            } else if (this.subscriptions.find(el => el.company_merchant_status === 'inactive')) {
                // If there is at least one inactive subscription
                return 'Aby móc aktywować tę promocję, aktywuj usługę producenta. Kliknij w promocję po więcej szczegółów.'
            }

            return ''
        },
        promoCheckboxDisabled() {
            return !this.subscriptions.find(el => el.state === 'available')
        },
        durationDays() {
            const { start_at, end_at } = this.promotion
            const start = moment(start_at)
            const end = moment(end_at)

            return end.diff(start, 'days') + 1
        },
        daysLeft() {
            const { start_at, end_at, state } = this.promotion

            return this.$store.getters.getDaysLeft({
                start_at,
                end_at,
                state
            })
        },
        progressWidth() {
            const daysToShowProgress = this.durationDays
            const daysLeft = this.daysLeft.left
            if (daysLeft < daysToShowProgress) {
                return (
                    (100 / daysToShowProgress) * (daysToShowProgress - daysLeft)
                )
            } else {
                return 0
            }
        },
        showState() {
            return this.previewType === 'promo-finished'
        },
        isSuspended() {
            return this.subscriptions.some(el => el.suspended === true)
        },
        isLocked() {
            const lockedAt = this.promotion.locked_at
            if (!lockedAt) {
                return false
            }

            const today = this.$moment()

            return this.$moment(lockedAt).isBefore(today)
        },
        showProgress() {
            return this.previewType === 'promo-yours'
        },
        showShopsCounter() {
            return (
                this.previewType !== 'promo-finished' &&
                this.previewType !== 'promo-labels' &&
                this.previewType !== 'labels'
            )
        },
        showProductsCounter() {
            return this.previewType === 'promo-labels'
        },
        showNetReturn() {
            return (
                this.promotion.type !== PROMO_TYPES.ADVERTISEMENT &&
                (this.previewType === 'promo-list' ||
                    this.previewType === 'promo-later')
            )
        },
        showHeart() {
            return (
                this.previewType === 'promo-list' ||
                this.previewType === 'promo-later'
            )
        },
        showButtons() {
            return (
                this.previewType === 'promo-list' ||
                this.previewType === 'promo-later' ||
                this.previewType === 'promo-labels'
            )
        },
        shopsCounterKeyword() {
            let keyword = 'available'
            if (this.previewType === 'promo-yours') {
                keyword = 'accepted'
            }
            return keyword
        },
        shopsCounterTitle() {
            if (this.previewType === 'promo-yours') {
                return 'Aktywna'
            }

            return 'Dostępna'
        },
        group() {
            return this.$store.getters.getPromoGroup(this.groupId)
        },
        selected() {
            const group = this.$store.getters.getSelectedPromoGroup(
                this.groupId
            )
            if (group) {
                const selectedPromoIds = group.selectedPromoIds
                return selectedPromoIds.includes(this.promotion.id)
            } else {
                return false
            }
        },
        promoType() {
            return this.$store.getters.getPromoTypeByValue(this.promotion.type)
        },
        totalRefund() {
            return this.$functions.calculateRefund(this.promotion)
        },
        isPromoEditPermission() {
            return this.$store.getters.isPromoEditPermission
        },
        showAttachmentsBtn() {
            return (
                (this.promotion.attachments || []).length &&
                (this.previewType === 'promo-list' ||
                    this.previewType === 'promo-later' ||
                    this.previewType === 'promo-yours' ||
                    this.previewType === 'promo-finished')
            )
        },
        promoAttachmentsStatus() {
            return this.$store.getters.getPromoAttachmentsStatus
        },
        isPromoLabels() {
            const { loyalty, featured } = this.promotion
            return (
                this.$route.name !== 'promo-finished' &&
                ((this.promotion.subscriptions_auto_acceptance &&
                    this.isActivePromosTab) ||
                    featured ||
                    loyalty)
            )
        },
        selectLabel() {
            return this.$store.getters.getSelectedLabelGroupBoolean(
                this.promotion.id,
                this.groupId
            )
        },
        company() {
            return this.promotion.company
        },
        promotionName() {
            const { promotion } = this

            let name = promotion.name

            const set = promotion.own_mix_product_sets?.[0]

            if (set) {
                name += ` - w cenie ${this.$options.filters.currency(
                    set.price / +set.required_weight
                )}/szt. przy zakupie ${+set.required_weight} szt.`
            }

            return name
        },

        selectionConflict() {
            if (this.promotion.marketingPromoConflict) {
                return 'Nie możesz aktywować tej promocji bez aktywacji usługi organizatora'
            }

            return ''
        },

        totalProductsRecords() {
            return +this.promotion.totalProductsRecords
        },

        emptyMandatoryPrice() {
            return this.promotion.emptyMandatoryPrice
        }
    },
    methods: {
        selectDeselectPromo(select) {
            this.$store.dispatch('selectPromoGroupPromo', {
                promoId: this.promotion.id,
                groupId: this.groupId,
                select,
                acceptance: this.acceptance
            })
        },
        onPromotionDelete() {
            if (this.$route.name === 'labels') {
                this.$store.dispatch('openConfirmationWindow', {
                    message:
                        'Czy na pewno chcesz usunąć promocję z procesu generowania cenówek?',
                    abortButtonText: 'Zamknij okno',
                    confirmButtonText: 'Usuń ',
                    confirmButtonCallback: () => {
                        this.$store.dispatch('selectLabelGroupLabel', {
                            promoId: this.promotion.id,
                            value: false,
                            groupId: this.groupId,
                            groups: this.$store.getters.getSelectedLabelGroups
                        })

                        if (
                            this.$store.getters.getSelectedLabelGroups
                                .length === 0
                        ) {
                            this.$store.dispatch('toggleModal', false)
                        }
                    }
                })
            } else {
                if (this.acceptance === 'all') {
                    this.$store.dispatch('openConfirmationWindow', {
                        message:
                            'Promocja należy do grupy zamkniętej. Usunięcie tej promocji skutkuje usunięciem całej grupy. <br /> Czy na pewno chcesz usunąć całą grupę z aktywacji?',
                        abortButtonText: 'Zamknij okno',
                        confirmButtonText: 'Usuń grupę',
                        confirmButtonCallback: async () => {
                            await this.$store.dispatch('selectPromoGroup', {
                                groupId: this.groupId,
                                select: false
                            })
                            if (
                                this.$store.getters.getSelectedPromoGroups
                                    .length === 0
                            ) {
                                this.$store.dispatch('toggleModal', false)
                            }
                        }
                    })
                } else {
                    this.$store.dispatch('openConfirmationWindow', {
                        message:
                            'Czy na pewno chcesz usunąć promocję z aktywacji?',
                        abortButtonText: 'Zamknij okno',
                        confirmButtonText: 'Usuń ',
                        confirmButtonCallback: () => {
                            this.selectDeselectPromo(false)

                            if (
                                this.$store.getters.getSelectedPromoGroups
                                    .length === 0
                            ) {
                                this.$store.dispatch('toggleModal', false)
                            }
                        }
                    })
                }
            }
        },
        onPromotionSelect() {
            if (this.isLocked || this.lockedTimesUp) {
                return
            }
            this.selectDeselectPromo(!this.selected)
        },
        async onPromoLabelSelect() {
            this.loaderSelectLabel = 'loading'
            await this.$store.dispatch('selectLabelGroupLabel', {
                promoId: this.promotion.id,
                value: !this.selectLabel,
                groupId: this.groupId,
                groups: this.$store.getters.getLabelGroups
            })
            this.loaderSelectLabel = 'idle'
        },
        toggleFavorites(promoId, favorite) {
            this.$store.dispatch('toggleFavorites', {
                promoId,
                favorite
            })
        },
        async onAttachmentsDownload(id, name) {
            this.$store.dispatch('setPromoAttachmentsStatus', {
                status: 'loading',
                promoId: id
            })
            if (this.promotion.attachments.length === 1) {
                await this.$functions.downloadFile(
                    this.promotion.attachments[0].urls.original,
                    name,
                    id
                )
            } else {
                await this.$store.dispatch('fetchPromotionAttachments', {
                    id,
                    name,
                    merchantNetworkId: [
                        ...new Set(
                            this.subscriptions.map(e => e.merchant_network_id)
                        )
                    ]
                })
            }
            this.$store.dispatch('setPromoAttachmentsStatus', {
                status: 'idle',
                promoId: id
            })
        },

        setLockedAt() {
            if (!this.promotion.locked_at) {
                return
            }

            const lockedAt = moment(this.promotion.locked_at).utc()
            const today = moment().utc()
            const hoursThreshold = moment().utc().add(3, 'days')

            // if locked_at is before now
            if (lockedAt.isBefore(today)) {
                this.lockedAtText = 'Aktywacja promocji zablokowana'
                this.lockedTimesUp = true
            } else if (lockedAt.isBefore(hoursThreshold)) {
                /**
                 * If locked_at is before 3 days from now
                 * set timer, display text 'Aktywacja możliwa jeszcze przez: HH:mm:ss'
                 */
                const setText = () => {
                    const duration = moment.duration(lockedAt.diff(moment().utc()))

                    // Get the total number of milliseconds, then convert to hours
                    const totalHours = Math.floor(duration.asHours()) // Hours including full days
                    const minutes = duration.minutes()
                    const seconds = duration.seconds()

                    if (totalHours === 0 && minutes === 0 && seconds === 0) {
                        clearInterval(this.lockedAtInterval)
                        this.lockedAtText = 'Aktywacja promocji zablokowana'
                        this.lockedTimesUp = true
                    } else {
                        this.lockedAtText = `Aktywacja możliwa jeszcze przez: ${totalHours
                            .toString()
                            .padStart(2, '0')}:${minutes
                            .toString()
                            .padStart(2, '0')}:${seconds
                            .toString()
                            .padStart(2, '0')}`
                        this.lockedTimesUp = false
                    }
                }

                setText()

                this.lockedAtInterval = setInterval(() => {
                    setText()
                }, 1000)
            } else {
                this.lockedAtText = `Aktywuj do: ${lockedAt.format(
                    'DD-MM-YYYY, HH:mm'
                )}`
                this.lockedTimesUp = false
            }
        },
        onChangeShowMore() {
            this.$emit('showMore')
            if (!this.changedShowMore) {
                this.changedShowMore = true
            }
        }
    },

    mounted() {
        this.setLockedAt()
    },

    beforeMount() {
        if (this.lockedAtInterval) {
            clearInterval(this.lockedAtInterval)
        }
    }
}
</script>
